import React from 'react';
import ReactDOM from 'react-dom/client';
import configuration from 'configuration';
import App from 'App';
import {AppContextProvider} from 'AppContext';

import 'react-slideshow-image/dist/styles.css';
import 'index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

configuration
  .init()
  .then(() =>
    root.render(
      <React.StrictMode>
        <AppContextProvider>
          <App />
        </AppContextProvider>
      </React.StrictMode>,
    ),
  )
  .catch(e => console.error('failed to initReactI18next', e));
